import { AppBar, Toolbar, Box, Container } from '@mui/material'
import logo from '@/assets/images/logo.png'

export const Navbar = () => {
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundImage: 'linear-gradient(90deg, #430397, #fe2f61)',
        borderBottom: 'none',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar
          sx={{
            justifyContent: 'flex-start',
            py: { xs: 2, md: 3 },
            minHeight: 'auto !important',
          }}
        >
          <Box
            sx={{
              height: { xs: '45px', md: '55px' },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={logo}
              alt="NBCU International Networks"
              style={{
                height: '100%',
                width: 'auto',
              }}
            />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
